import React from 'react'
import Pagination from 'react-js-pagination'
import { connect } from 'react-redux'
import Modal from 'react-responsive-modal'
import Toggle from 'react-toggle'
import AdvancedFilter from '../Components/AdvancedFilter'
import EllipsisModal from '../Components/EllipsisModal'
import CountryList from '../Containers/Product/CountryList'
import FormCreate from '../Containers/Product/FormCreate'
import ProductPreset from '../Containers/Product/ProductPreset'
import ProductVariants from '../Containers/Product/ProductVariants'
import UpdateContent from '../Containers/Product/UpdateContent'
import UpdateImage from '../Containers/Product/UpdateImage'
// import ProductCampaign from '../Containers/Product/ProductCampaign'
import PresetActions from '../Redux/PresetRedux'
import ProductActions from '../Redux/ProductRedux'
import { isoCodeConversion } from '../Utils/ConversionUtils'
import FormatMoney from '../Utils/FormatMoney'
import { currentBranch, currentCurrency } from '../Utils/PrivilegeUtils'
import filterData from './filterData.json'

class ProductPage extends React.Component {
  constructor (props) {
    super(props)
    this.branch = currentBranch()
    this.currency = currentCurrency()
    this.state = {
      tab: 'WifiProductList',
      showModal: null,
      filter: {
        sort: 'title',
        page: 1,
        q: '',
        iso_code: this.branch,
        currency_code: this.currency,
        status: ''
      },
      detail: {}
    }
  }

  componentDidMount = () => {
    this.props.getProduct(this.state.filter)
    this.branch === 'PH' && this.props.getBranch()
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.dataPresetOrder !== prevProps.dataPresetOrder) {
      this.props.getPreset()
    }
  }

  _changeTab = (tab) => {
    this.setState({ tab })
  }

  _toggleModal = (modalId = null) => {
    if (!modalId) this._fetchProduct()
    this.setState({ showModal: modalId })
  }

  _fetchProduct = (event, filter = this.state.filter) => {
    if (event) event.preventDefault()
    this.props.getProduct(filter)
  }

  _toggleSort = () => {
    let sort = this.state.filter.sort
    if (sort === 'title') {
      sort = '-title'
    } else {
      sort = 'title'
    }
    let filter = {
      ...this.state.filter,
      sort
    }
    this.setState({ filter })
    this._fetchProduct(null, { sort })
  }

  _selectItem = (item, action) => {
    this.setState({ detail: item })
    this._toggleModal(action)
  }

  _toggleField = (item, field) => {
    let form = {}
    let id = item.id
    switch (field) {
      case 'status':
        item.status === 'active'
          ? form.status = 'inactive'
          : form.status = 'active'
        break
      case 'use_dynamic_price':
        item.use_dynamic_price === 1
          ? form.use_dynamic_price = 0
          : form.use_dynamic_price = 1
        break
      default:
        break
    }
    form.iso_code = item.iso_code
    let data = { id, form }
    this.props.updateProduct(data)
    setTimeout(() => {
      this._fetchProduct()
    }, 250)
  }

  _changePage = (page) => {
    let filter = {
      ...this.state.filter,
      page
    }
    this.setState({ filter })
    this.props.getProduct(filter)
  }

  _delete = () => {
    const { id } = this.state.detail
    this.props.deleteProduct({ id })
    setTimeout(() => {
      this._toggleModal()
    }, 250)
  }

  _manipulateState = (props) => {
    let filter = { ...this.state.filter, ...props }
    filter.page = 1 // PAGINATION SAFETY RULE
    if (props.iso_code) {
      filter.currency_code = isoCodeConversion(props.iso_code)
    }
    this.setState({ filter })
  }

  _renderTable = (product) => {
    return (
      <section className='section'>
        <div className='card'>
          {
            !(product.fetching || product.processing) && product.err &&
            <div className='alert alert-danger'>{product.err}</div>
          }
          <div className='card-block'>
            <table className='table table-hover table-striped' style={{ minWidth: '100%' }}>
              <thead>
                <tr>
                  <th className='text-center' role='button' onClick={() => this._toggleSort()}>Title <span className='badge badge-info'><i className={`fas fa-${this.state.filter.sort === '-title' ? 'sort-amount-down' : 'sort-amount-up'}`} /></span></th>
                  <th className='text-center'>Description</th>
                  <th className='text-center'>Normal Price</th>
                  <th className='text-center'>Final Price</th>
                  <th className='text-center'>Currency Code</th>
                  <th className='text-center'>Status</th>
                  <th className='text-center'>Allow Coupon?</th>
                  <th className='text-center'>Image</th>
                  {/* <th className='text-center'>Campaign</th> */}
                  <th className='text-center' colSpan='2'>Dynamic Price</th>
                  <th className='text-center'>Update</th>
                  <th className='text-center'>Delete</th>
                </tr>
              </thead>
              <tbody>
                {
                  !product.data || !product.data.data.length
                    ? <tr>
                      <td colSpan='13' className='text-center'>- NO DATA -</td>
                    </tr>
                    : product.data.data.map((item, i) => (
                      <tr key={i}>
                        <td className='text-center'>{ item.title || '-' }</td>
                        <td className='text-center'>
                          <EllipsisModal type='string' descriptor='Product Description' name={item.title} description={item.description || ''} />
                        </td>
                        <td className='text-center'>{ FormatMoney(item.normal_price) }</td>
                        <td className='text-center'>{ FormatMoney(item.price) }</td>
                        <td className='text-center'>{ item.currency_code || '-' }</td>
                        <td className='text-center'>
                          <Toggle checked={item.status === 'active'} onChange={() => this._toggleField(item, 'status')} />
                        </td>
                        <td className='text-center'>{ item.use_coupon === 0 ? 'Not Allowed' : 'Allow' }</td>
                        <td className='text-center'>
                          <img src={item.image_url} alt='' className='img img-responsive' height='75px' />
                        </td>
                        {/* <td className='text-center'>
                          <button className='btn btn-info' onClick={() => this._selectItem(item, 'campaign')}><i className='fa fa-book' /> View</button>
                        </td> */}
                        <td className='text-center'>
                          <Toggle checked={item.use_dynamic_price === 1} onChange={() => this._toggleField(item, 'use_dynamic_price')} />
                        </td>
                        <td className='text-center'>
                          <button
                            className='btn btn-info'
                            onClick={() => this._selectItem(item, 'variants')}
                          >
                            <i className='fa fa-list' /> View</button>
                        </td>
                        <td className='d-flex justify-content-around'>
                          <button className='btn btn-primary mr-2' onClick={() => this._selectItem(item, 'countryList')}>
                            <i className='fa fa-globe' /> Country
                          </button>
                          <button className='btn btn-primary mr-2' onClick={() => this._selectItem(item, 'edit-content')}>
                            <i className='fa fa-edit' /> Content
                          </button>
                          <button className='btn btn-primary' onClick={() => this._selectItem(item, 'edit-image')}>
                            <i className='fa fa-image' /> Image
                          </button>
                        </td>
                        <td className='text-center'>
                          <button className='btn btn-danger' onClick={() => this._selectItem(item, 'delete')}>
                            <i className='fa fa-trash' />
                          </button>
                        </td>
                      </tr>
                    ))
                }
              </tbody>
            </table>
          </div>
        </div>
      </section>
    )
  }

  _renderPagination = (product) => {
    return (
      <section className='text-center'>
        {
          (product.data && product.data.total > 10) &&
          <Pagination
            innerClass='pagination'
            itemClass='page-item'
            linkClass='page-link'
            activePage={product.data.page || this.state.filter.page}
            itemsCountPerPage={10}
            totalItemsCount={product.data.total}
            pageRangeDisplayed={5}
            onChange={this._changePage}
          />
        }
      </section>
    )
  }

  render () {
    const { product, preset } = this.props
    return (
      <div>
        <header className='section'>
          <div className='title-block d-flex mb-3 justify-content-between'>
            <h3 className='title mr-auto'>
              Wifi Product { this.state.tab === 'WifiProductList' ? 'List' : 'Preset' }
              {
                (product.fetching || product.processing || preset.fetchingPresetOrder) &&
                <div className='badge badge-info ml-2'>{product.fetching ? 'Loading' : 'Processing'} ...</div>
              }
            </h3>
            { this.state.tab === 'WifiProductList' && <button className='btn btn-primary mr-2' onClick={() => this._toggleModal('create')}><i className='fa fa-plus' /> Create New</button> }
            <button className={`btn btn-primary ${this.state.tab === 'WifiProductList' ? 'active' : ''}`} onClick={() => this._changeTab('WifiProductList')}>Product List</button>
            <button className={`btn btn-primary ${this.state.tab === 'WifiProductPreset' ? 'active' : ''}`} onClick={() => this._changeTab('WifiProductPreset')}>Preset</button>
          </div>
          {
            this.state.tab === 'WifiProductList' &&
            <div className='title-block'>
              <AdvancedFilter
                filters={filterData.productFilters}
                manipulateState={(props) => this._manipulateState(props)}
                callback={(event) => this._fetchProduct(event)}
              />
            </div>
          }
        </header>

        { this.state.tab === 'WifiProductPreset' && <ProductPreset /> }
        { this.state.tab === 'WifiProductList' && this._renderTable(product) }
        { this.state.tab === 'WifiProductList' && this._renderPagination(product) }

        <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'create'} onClose={this._toggleModal} closeOnOverlayClick>
          <FormCreate closeModal={() => this._toggleModal()} />
        </Modal>

        <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'countryList'} onClose={this._toggleModal} closeOnOverlayClick>
          <CountryList title={this.state.detail.title} uuid={this.state.detail.id} closeModal={() => this._toggleModal()} />
        </Modal>

        <Modal open={this.state.showModal === 'edit-content'} onClose={this._toggleModal} closeOnOverlayClick>
          <UpdateContent detail={this.state.detail} closeModal={() => this._toggleModal()} />
        </Modal>

        <Modal open={this.state.showModal === 'edit-image'} onClose={this._toggleModal} closeOnOverlayClick>
          <UpdateImage detail={this.state.detail} closeModal={() => this._toggleModal()} />
        </Modal>

        {/* <Modal center classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'campaign'} onClose={this._toggleModal} closeOnOverlayClick>
          <ProductCampaign productID={this.state.detail.id} closeModal={() => this._toggleModal()} />
        </Modal> */}

        <Modal center classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'variants'} onClose={this._toggleModal} closeOnOverlayClick>
          <ProductVariants detail={this.state.detail} closeModal={() => this._toggleModal()} />
        </Modal>

        <Modal open={this.state.showModal === 'delete'} onClose={this._toggleModal} closeOnOverlayClick>
          <div className='section' style={{ width: '40vw' }}>
            <div className='title-block'>
              <h4 className='title mr-auto'>Delete Product?</h4>
            </div>
            <div className='section text-center'>
              <h5>{ this.state.detail.title || '-' }</h5>
              <div>
                <button type='button' className='btn btn-secondary mr-2' onClick={() => this._toggleModal()}>Cancel</button>
                <button className='btn btn-danger' onClick={() => this._delete()}>Delete</button>
              </div>
            </div>
          </div>
        </Modal>

      </div>
    )
  }
}

const stateToProps = (state) => ({
  product: state.product,
  preset: state.preset
})

const dispatchToProps = (dispatch) => ({
  getProduct: (filter) => dispatch(ProductActions.productRequest(filter)),
  deleteProduct: (data) => dispatch(ProductActions.productDeleteRequest(data)),
  getPreset: (data) => dispatch(PresetActions.presetOrderRequest(data)),
  updateProduct: (data) => dispatch(ProductActions.productUpdateRequest(data)),
  getBranch: () => dispatch(PresetActions.getBranchRequest())
})

export default connect(stateToProps, dispatchToProps)(ProductPage)



// WEBPACK FOOTER //
// ./src/Pages/ProductPage.js